import React, { useEffect, useState } from "react";
import { InputNumber, Checkbox, Row, Col, Spin } from "antd";

const LocationPicker = ({
  form,
  initialLat,
  initialLon,
  initialRadius,
  initialHideOutside,
}) => {
  const [position, setPosition] = useState([
    initialLat || 55.751244,
    initialLon || 37.618423,
  ]);
  const [radius, setRadius] = useState(initialRadius || 1);
  const [hideOutside, setHideOutside] = useState(initialHideOutside || false);
  const [MapComponent, setMapComponent] = useState(null);
  const [isClient, setIsClient] = useState(false);

  // Проверка, что мы на клиенте
  useEffect(() => {
    setIsClient(true);
    // Динамический импорт react-leaflet только на клиенте
    import("./LazyMap").then((module) => {
      setMapComponent(() => module.default);
    });
  }, []);

  // Обновляем форму при изменении данных
  useEffect(() => {
    if (form) {
      form.setFieldsValue({
        latitude: position[0],
        longitude: position[1],
        radius,
        hide_outside_radius: hideOutside,
      });
    }
  }, [position, radius, hideOutside, form]);

  return (
    <div style={{ marginBottom: 16 }}>
      {isClient && MapComponent ? (
        <div className="relative">
          <MapComponent
            position={position}
            setPosition={setPosition}
            radius={radius}
          />
          <div className="w-full h-[20px] bg-white absolute z-[10000] bottom-0 right-0" />
        </div>
      ) : (
        <div
          style={{
            height: 400,
            background: "#f5f5f5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin tip="Загрузка карты..." />
        </div>
      )}
      <Row gutter={16} style={{ marginTop: 16 }}>
        <Col span={12}>
          <InputNumber
            min={0.1}
            max={100}
            step={0.5}
            value={radius}
            onChange={(val) => setRadius(val || 0)}
            style={{ width: "100%" }}
            addonBefore="Радиус (км)"
          />
        </Col>
        <Col span={12}>
          <Checkbox
            checked={hideOutside}
            onChange={(e) => setHideOutside(e.target.checked)}
          >
            Скрывать цену вне радиуса
          </Checkbox>
        </Col>
      </Row>
      <div style={{ fontSize: 12, color: "#888", marginTop: 8 }}>
        * Кликните на карту, чтобы установить точку. Радиус влияет на приоритет
        цены.
      </div>
    </div>
  );
};

export default LocationPicker;
